<template>
  <div v-if="!item.hidden&&item.children">
    <!-- 如果 item 只有一个可见的子项，并且该子项没有子项或没有可见的子项，并且 item 不总是显示，则渲染这个模板 -->
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">

      <!-- 渲染一个 div，点击时触发 linkclick 方法 -->
      <div :to="resolvePath(onlyOneChild.path)" :key="onlyOneChild.path" @click="linkclick(resolvePath(onlyOneChild.path))">

        <!-- 渲染一个菜单项，显示 onlyOneChild 的图标和标题 -->
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item v-if="onlyOneChild.meta" :icon="onlyOneChild.meta.icon||item.meta.icon" :title="onlyOneChild.meta.title" />
        </el-menu-item>
      </div>
    </template>

    <el-submenu
      v-else
      ref="subMenu"
      :index="resolvePath(item.path)+item.id"
      :class="`level-${item.levle}`"
      popper-append-to-body
    >
      <template slot="title">
        <item
          v-if="item.meta"
          :icon="item.meta && item.meta.icon"
          :title="item.meta.title"
        />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.id"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        :level="`${child.levle + 1}`"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    hasOneShowingChild(children,parent) {
      const { is_group } = parent
      if (is_group === 'Y') { // 是否是目录
        return false
      }
      const showingChildren = children.filter((item) => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },

    resolvePath(routePath) {
      if (this.isExternalLink(routePath)) {
        return routePath
      }
      return path.resolve(this.basePath, routePath)
    },

    isExternalLink(routePath) {
      return isExternal(routePath)
    },

    linkclick(path) {
      this.$nextTick(() => {
        this.$router.replace({
          path: '/redirect' + path,
          query: {
            t: +new Date() // 保证每次点击路由的query项都是不一样的，确保会重新刷新view
          }
        })
      })
    }

  }
}
</script>
